import { BehaviorSubject } from 'rxjs';
import type { FlightCategory } from '@/shared/types';
import { getFlightCategories } from '../api/flightCategories.api';

function createFlightCategoriesService() {
  const categories$ = new BehaviorSubject<FlightCategory[]>([]);
  const error$ = new BehaviorSubject<boolean>(false);
  let loaded = false;

  function load() {
    if (loaded) return;
    loaded = true;
    error$.next(false);
    getFlightCategories().subscribe({
      next: cats => categories$.next([...cats].sort((a, b) => a.order - b.order)),
      error: () => { loaded = false; error$.next(true); },
    });
  }

  function getById(id: string): FlightCategory | undefined {
    return categories$.value.find(c => c.id === id);
  }

  return { categories$, error$, load, getById };
}

export const flightCategoriesService = createFlightCategoriesService();
